<template>
  <div class="quote__list-insured">
    <div class="quote__accordion">
      <BaseAccordion :alwaysDisplay="alwaysDisplay">
        <template v-slot:name>
          <slot name="title">
            {{$t('qic_quote_owner_info')}}
          </slot>
        </template>
        <template v-slot:content>
          <ul class="quote__policy-list">
            <div v-if="editable" class="quote__edit" @click="openEditForm"></div>
            <li v-if="firstName && lastName">
                <div class="quote__policy-name">{{$t('qic_user_full_name')}}</div>
                <div class="quote__policy-value">{{ firstName_ }} {{ lastName_ }}</div>
            </li>
            <li v-if="fullName">
                <div class="quote__policy-name">{{$t('qic_user_full_name')}}</div>
                <div class="quote__policy-value">{{ fullName_ }}</div>
            </li>
            <li v-if="formattedDob">
                <div class="quote__policy-name">{{$t('qic_user_dob')}}</div>
                <div class="quote__policy-value">{{ formattedDob }}</div>
            </li>
            <li v-if="qid">
                <div class="quote__policy-name">{{$t('qic_user_qid_placeholder')}}</div>
                <div class="quote__policy-value">{{ qid_ }}</div>
            </li>
            <li v-if="passport">
                <div class="quote__policy-name">{{$t('qic_quote_member_passport')}}</div>
                <div class="quote__policy-value">{{ passport_ }}</div>
            </li>
            <li v-if="phone">
                <div class="quote__policy-name">{{$t('qic_user_contacts_mobile_phone')}}</div>
                <div class="quote__policy-value">{{ phone_ }}</div>
            </li>
            <li v-if="email">
                <div class="quote__policy-name">{{$t('qic_user_contacts_email')}}</div>
                <div class="quote__policy-value">{{ email_ }}</div>
            </li>
          </ul>
        </template>
      </BaseAccordion>
    </div>
    <base-popup-wrapper @close="closeEditForm" v-if="editFormShown">
      <div class="modal_titleForm">{{ $t('qic_popup_update_info') }}</div>
      <div class="inputList">
        <base-input
          v-if="fullName !== undefined"
          :validation="$v.userInfo.fullName"
          :placeholder="$t('qic_user_full_name')"
          v-model="userInfo.fullName"
          @blur="blurName"
        >
        </base-input>
        <base-input
          v-if="phone !== undefined "
          :validation="$v.userInfo.phone"
          :placeholder="$t('qic_user_contacts_mobile_phone')"
          ref="phoneInput"
          @input="onPhoneNumberInput"
          v-model="userInfo.phone"
          :mask="'#'.repeat(13)">
        </base-input>
        <base-input
          v-if="qid !== undefined "
          :validation="$v.userInfo.qid"
          :placeholder="$t('qic_user_qid_placeholder')"
          v-model="userInfo.qid"
          :mask="'#'.repeat(11)"
          @blur="blurQid"
        >
        </base-input>
        <base-input
          v-if="email !== undefined"
          :validation="$v.userInfo.email"
          :placeholder="$t('qic_user_contacts_email')"
          v-model="userInfo.email">
        </base-input>
      </div>
      <template v-slot:button>
        <base-button symbol="no" class="btn-second_medium" @click="onEdit">
          {{ $t('qic_save_and_close') }}
        </base-button>
      </template>
    </base-popup-wrapper>
  </div>
</template>

<script>
import BaseAccordion from '../BaseAccordion.vue'
import BasePopupWrapper from '../popups/BasePopupWrapper'
import BaseButton from '../buttons/BaseButton'
import { required, email, minLength, maxLength, numeric } from 'vuelidate/lib/validators'
export default {
  name: 'QuotePolicyOwner',
  props: {
    dob: {},
    firstName: { type: String },
    lastName: { type: String },
    fullName: { type: String },
    qid: { type: [String, Number] },
    passport: { type: [String, Number] },
    email: { type: String },
    phone: { type: [String, Number] },
    editable: { type: Boolean, default: false },
    alwaysDisplay: { type: Boolean, default: false }
  },
  emits: ['edit'],
  components: {
    BaseAccordion,
    BasePopupWrapper,
    BaseButton
  },
  computed: {
    formattedDob () {
      if (!this.dob_ || !this.dob_.getFullYear || isNaN(this.dob_.getFullYear())) return null
      return `${this.padZero(this.dob_.getDate(), 2)}.${this.padZero(this.dob_.getMonth() + 1, 2)}.${this.dob_.getFullYear()}`
    },
    dob_ () {
      return this.dob
    },
    firstName_ () {
      return this.firstName
    },
    lastName_ () {
      return this.lastName
    },
    fullName_ () {
      return this.fullName
    },
    qid_ () {
      return this.qid
    },
    passport_ () {
      return this.passport
    },
    email_ () {
      return this.email
    },
    phone_ () {
      return this.phone
    }
  },
  data () {
    return {
      editFormShown: false,
      userInfo: {}
    }
  },
  methods: {
    blurQid () {
      const userQid = this.userInfo.qid
      const numberOfSymbols = userQid.length
      this.$emit('blurQid', {
        numberOfSymbols
      })
    },
    blurName () {
      const fullName = this.userInfo.fullName
      const numberOfSymbols = fullName.length
      this.$emit('blurName', {
        numberOfSymbols
      })
    },
    padZero (value, pad) {
      const valueLength = String(value).length
      if (valueLength <= pad) {
        const padNumber = pad - valueLength
        let result = String(value)
        result = '0'.repeat(padNumber) + result
        return result
      }
      return value
    },
    openEditForm () {
      this.userInfo = {
        fullName: this.fullName_,
        phone: this.phone_,
        qid: this.qid_,
        email: this.email_
      }
      this.editFormShown = true
      const body = document.querySelector('body')
      body.classList.add('overflow-off')
      this.$emit('openEditOwner')
    },
    closeEditForm () {
      this.editFormShown = false
      const body = document.querySelector('body')
      body.classList.remove('overflow-off')
    },
    onEdit () {
      this.$v.$touch()
      if (this.$v.$invalid) return
      this.editFormShown = false
      this.closeEditForm()
      this.$emit('edit', this.userInfo)
    },
    onPhoneNumberInput (value) {
      const oldValue = this.userInfo.phone
      if (!Number(value.replace('+', ''))) {
        this.$refs.phoneInput.$refs.input.value = oldValue
        return
      }
      if (!value.includes('+')) {
        this.userInfo.phone = '+' + String(value)
        return
      }
      this.userInfo.phone = value
    }
  },
  beforeDestroy () {
    const body = document.querySelector('body')
    body.classList.remove('overflow-off')
  },
  validations () {
    const userInfo = {}
    if (this.fullName !== undefined) {
      userInfo.fullName = {
        required
      }
    }
    if (this.phone !== undefined) {
      userInfo.phone = {
        required,
        minLength: minLength(10),
        maxLength: maxLength(13),
        phoneRule: (value) => numeric(value) || value.includes('+')
      }
    }
    if (this.qid !== undefined) {
      userInfo.qid = {
        required,
        // validFormat: val => /\d{11}$/.test(val),
        validFormat: val => /^[123]/.test(val),
        lengthConstraint: (val) => {
          return String(val).length === 8 || String(val).length === 11
        }
      }
    }
    if (this.email !== undefined) {
      userInfo.email = {
        email,
        required
      }
    }
    return {
      userInfo
    }
  }
}
</script>
